/* eslint-disable @typescript-eslint/no-explicit-any */
import * as React from 'react';
import {
  checkFormHasError,
  getFormHelperText,
  handleBlurFormField,
  handleChangeFormField,
} from 'ui/forms/formHelpers';
import { useField } from 'formik';
import SelectField, { SelectFieldProps } from 'ui/SelectField/SelectField';

/**
 * @deprecated Fine to use for Tock internal tools only. Please use `@tocktix/pantry` UI components for any new JCE admin tools.
 */
function FormSelectField({
  SelectProps,
  children,
  helperText,
  name,
  id,
  onChange,
  onBlur,
  ...rest
}: SelectFieldProps) {
  const idValue = id ? id : SelectProps?.inputProps?.id;
  const fieldProps = {
    ...SelectProps?.inputProps,
    name: name ? name : SelectProps?.inputProps?.name,
    id: idValue,
  };
  const [field, meta] = useField(fieldProps);

  const handleChange = (event: React.ChangeEvent<any>, child: any) =>
    handleChangeFormField(field, event, onChange ? onChange : (SelectProps?.onChange as any));

  const handleBlur = (event: React.FocusEvent<any>) =>
    handleBlurFormField(field, event, onBlur ? onBlur : SelectProps?.onBlur);

  const hasError = checkFormHasError(meta);

  const helperTextValue = getFormHelperText(hasError, meta, helperText);

  return (
    <SelectField
      error={hasError}
      helperText={helperTextValue as string}
      {...(field as any)}
      {...rest}
      id={idValue}
      onChange={handleChange}
      onBlur={handleBlur}
      SelectProps={SelectProps}
    >
      {children}
    </SelectField>
  );
}

export default FormSelectField;
